import React, { useEffect } from 'react'
import Modal from 'antd/es/modal'
import Form from 'antd/es/form'
import Input from 'antd/es/input'
import Button from 'components/button'
import { CustomerEmployee } from 'models/'
import Notification from 'antd/es/notification'
import Space from 'antd/es/space'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { generateMongoId } from 'functions/generate-mongo-id'
import Select from 'antd/es/select'
import { Customer } from 'models/customer'
import { Employee } from 'models'
import './style.scss'

type Props = {
  editableItem: Customer | undefined
  employees: Employee[] | undefined
  visible: boolean
  data: CustomerEmployee[] | undefined
  onSave: (data: CustomerEmployee[]) => void
  onCancel: () => void
}

export const ModifyContacts = (props: Props) => {
  const [form] = Form.useForm()

  const onFinish = (result: { employees: CustomerEmployee[] }) => {
    try {
      const output: CustomerEmployee[] = []

      result.employees.forEach((item) => {
        const mapped: CustomerEmployee = {
          _id: item._id,
          assignment_ids: item.assignment_ids || [],
          hour_rate: item.hour_rate || undefined
        }

        output.push(mapped)
      })
      props.onSave(output)
      props.onCancel()
    } catch (e) {
      console.log(e)
      Notification.error({ message: JSON.stringify(e) })
    }
  }

  useEffect(() => {
    form.resetFields()
  }, [props.visible])

  return (
    <Modal
      style={{ width: '700px', minWidth: '700px' }}
      visible={props.visible}
      title={'Lisää toimeksianto'}
      onCancel={() => {
        props.onCancel()
      }}
      closable={false}
      closeIcon={false}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label="Peruuta"
            onClick={() => {
              props.onCancel()
            }}
            color="default"
          />
          <Button
            label="Tallenna"
            onClick={() => {
              form.submit()
            }}
            color="green"
          />
        </Button.ButtonGroup>
      }
    >
      <Form form={form} name="basic" onFinish={onFinish} onFinishFailed={() => {}} autoComplete="off">
        <Form.List name="employees" initialValue={props.data}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item hidden={true} {...restField} name={[name, '_id']} fieldKey={[fieldKey, '_id']}></Form.Item>
                  <Form.Item {...restField} name={[name, '_id']} fieldKey={[fieldKey, '_id']} rules={[{ required: true, message: 'Anna nimi' }]}>
                    <Select
                      style={{ width: '200px' }}
                      placeholder={'Valitse työntekijä'}
                      optionFilterProp="children"
                      showSearch={true}
                      suffixIcon={<></>}
                      filterOption={(input, option) => String(option?.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                      {(() => {
                        const selectedEmployeeId = form.getFieldValue(['employees', name, '_id'])
                        const cityEmployees =
                          props.employees?.filter((e) => JSON.stringify(e.city) === JSON.stringify(props.editableItem?.city)) || []
                        const selectedEmployee = props.employees?.find((employee) => employee._id === selectedEmployeeId)
                        const includeSelected =
                          selectedEmployee && !cityEmployees.some((employee) => employee._id === selectedEmployee._id)
                            ? [selectedEmployee, ...cityEmployees]
                            : cityEmployees

                        return includeSelected.map((employee) => {
                          return (
                            <Select.Option key={employee._id} value={employee._id}>
                              {employee.last_name + ' ' + employee.first_name}
                            </Select.Option>
                          )
                        })
                      })()}
                    </Select>
                  </Form.Item>
                  <Form.Item {...restField} name={[name, 'assignment_ids']} fieldKey={[fieldKey, 'assignment_ids']}>
                    <Select
                      className={'c-add-employee-to-customer-multiselect'}
                      mode="multiple"
                      placeholder={'Valitse toimeksianto'}
                      optionFilterProp="children"
                      showSearch={true}
                      suffixIcon={<></>}
                      filterOption={(input, option) => String(option?.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                      {props.editableItem?.assignments.map((assingment) => {
                        return (
                          <Select.Option key={assingment._id} value={assingment._id}>
                            {assingment.name}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item style={{ width: '100px' }} {...restField} name={[name, 'hour_rate']} fieldKey={[fieldKey, 'hour_rate']}>
                    <Input placeholder="Tuntihinta" type={'number'} min="0"
                      onKeyPress={(e) => {
                        if (e.key === "-" || e.key === "–" || e.key === "—") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>

                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                <div>
                  <Button
                    label="Lisää työntekijä"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    color="green"
                    style={{ width: '100%', justifyContent: 'center' }}
                  />
                </div>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  )
}

export default ModifyContacts
